import React from 'react';
import PropTypes from 'prop-types';
import { DragLayer } from '../../../drag-and-drop';
import { DnDOffset, TreeViewListItemType } from '../../constants/types';
import { ITEM_TYPES } from '../../constants/item-types';
import getParentsTransformShift from '../../helpers/get-parents-transform-shift';
import TreeViewItem from '../tree-view-item/item';

const DRAG_PREVIEW_HEIGHT = 48;
const DRAG_TRIGGER_LEFT_SHIFT = 18;
const DRAG_TRIGGER_SIZE = 16;

const collect = (monitor) => ({
  initialOffset: monitor.getInitialSourceClientOffset(),
  clientOffset: monitor.getClientOffset(),
  draggingItem: monitor.getItem(),
  itemType: monitor.getItemType(),
});

const getItemStyles = (clientOffset, initialOffset, parentEl) => {
  const { x, y } = clientOffset;

  const shift = {
    x: DRAG_TRIGGER_LEFT_SHIFT + DRAG_TRIGGER_SIZE / 2,
    y: DRAG_PREVIEW_HEIGHT / 2 - DRAG_TRIGGER_SIZE / 3,
  };

  const transform = `translate(${x - initialOffset.x - shift.x}px, ${
    y - initialOffset.y - shift.y
  }px)`;

  const parentOffset = getParentsTransformShift(parentEl);

  return {
    top: initialOffset.y - parentOffset.y,
    left: initialOffset.x - parentOffset.x,
    transform,
  };
};

const TreeViewItemDragPreview = ({
  draggingItem = null,
  clientOffset = null,
  initialOffset = null,
  itemType = null,
  containerEl,
}) => {
  if (!draggingItem || !clientOffset || itemType !== ITEM_TYPES.listItem) {
    return null;
  }

  const { item } = draggingItem;
  const { title, iconGlyph } = item;

  return (
    <div
      className="ws-ui-tree-view-item-drag-preview"
      style={{ ...getItemStyles(clientOffset, initialOffset, containerEl) }}
    >
      <TreeViewItem isDragging title={title} iconGlyph={iconGlyph} draggable={false} />
    </div>
  );
};

TreeViewItemDragPreview.propTypes = {
  draggingItem: PropTypes.shape({
    item: TreeViewListItemType,
  }),
  initialOffset: DnDOffset,
  clientOffset: DnDOffset,
  itemType: PropTypes.string,
  containerEl: PropTypes.instanceOf(Element).isRequired,
};

export default DragLayer(collect)(TreeViewItemDragPreview);
